import { withTheming, Shape, getFocusStyles, BorderRadius, Inset } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { SizeNames } from './constants.js';
import { getColorSemantic } from './utils.js';

var PILL_BORDER_RADIUS = 1000;

var getDisplay = function getDisplay(props) {
  return props.isInline ? 'inline-flex' : 'flex';
};

var SelectGroupButton = withTheming(styled.button.withConfig({
  displayName: "styles__SelectGroupButton",
  componentId: "sc-p3lsxh-0"
})(["position:relative;max-width:100%;margin:0;padding:0;display:", ";background-color:", ";min-height:", "px;width:auto;align-items:center;justify-content:center;box-shadow:", ";border-radius:", "px;border:none;color:", ";cursor:", ";transition:background-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;user-select:none;text-decoration:none;text-align:center;&::-moz-focus-inner{outline:none;border-style:none;padding:0;}&:focus{", ";}&:hover{background-color:", ";box-shadow:", ";color:", ";}&:active{background-color:", ";box-shadow:", ";color:", ";}"], getDisplay, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background'
  })];
}, function (props) {
  return props.theme.Size["Button".concat(SizeNames[props.size])];
}, function (props) {
  return "inset 0 0 0 ".concat(props.isSelected ? props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOn")] : props.theme.BorderWidth["Button".concat(props.kind, "ToggleGroupOff")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border'
  })]);
}, function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground'
  })];
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
}, getFocusStyles(), function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Hovered'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Hovered'
  })]);
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Hovered'
  })];
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Background',
    state: 'Pressed'
  })];
}, function (props) {
  return "inset 0 0 0 ".concat(props.theme.BorderWidth["Button".concat(props.kind, "Toggle")], "px ").concat(props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Border',
    state: 'Pressed'
  })]);
}, function (props) {
  return props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    isSelected: props.isSelected,
    kind: props.kind,
    section: 'Foreground',
    state: 'Pressed'
  })];
}));
var SelectGroupContainer = withTheming(styled.div.withConfig({
  displayName: "styles__SelectGroupContainer",
  componentId: "sc-p3lsxh-1"
})(["border-radius:", "px;", ";& > *{", ";border-radius:", " !important;}& > * + *{margin-left:-1px !important;}", ";"], function (props) {
  return props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === Shape.Pill ? PILL_BORDER_RADIUS : props.theme.BorderRadius.ButtonDefault;
}, function (props) {
  return !props.isInline ? css(["display:flex;width:100%;"]) : css(["display:inline-block;max-width:100%;"]);
}, function (props) {
  return !props.isInline ? css(["flex:1;"]) : '';
}, BorderRadius.None, function (props) {
  var borderRadiusValue = props.kind.includes('PILL') || props.theme.Shape.ButtonToggleGroup === Shape.Pill ? 1000 : props.theme.BorderRadius.ButtonDefault;
  return css(["background-color:", ";& > *:first-child{border-radius:", "px 0 0 ", "px !important;}& > *:last-child{border-radius:0 ", "px ", "px 0 !important;}& > *:nth-child(", "){z-index:1 !important;}", ";"], props.theme.Colors[getColorSemantic({
    isDisabled: props.isDisabled,
    kind: props.kind,
    section: 'Background'
  })], borderRadiusValue, borderRadiusValue, borderRadiusValue, borderRadiusValue, (props.selectedIndex ? props.selectedIndex : 0) + 1, typeof props.selectedIndex === 'number' && css(["& > *:nth-child(", "){border-radius:", "px !important;}& > *:nth-child(", "){margin-right:-", "px !important;padding-right:", "px;}& > *:nth-child(", "){margin-left:-", "px !important;padding-left:", "px;}"], props.selectedIndex + 1, borderRadiusValue, props.selectedIndex, props.size, props.size, props.selectedIndex + 2, props.size, props.size));
}));
var TextOverflow = styled(Inset).attrs(function (props) {
  return {
    verticalSize: Inset.Sizes.None,
    horizontalSize: props.size
  };
}).withConfig({
  displayName: "styles__TextOverflow",
  componentId: "sc-p3lsxh-2"
})(["max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);

export { SelectGroupButton, SelectGroupContainer, TextOverflow };
